export function allowsInput(item) {
  if (item.calculator_input?.length > 0) {
    const calculatorInput = item.calculator_input[0]
    return calculatorInput && calculatorInput.unit && calculatorInput.unit.length > 0
  } else {
    return false
  }
}
